import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "term_condition_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-start" }, null, -1)
const _hoisted_5 = { class: "modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-left mb-13" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mh-375px scroll-y me-n7 pe-7" }, [
    /*#__PURE__*/_createElementVNode("text", { class: "mb-3 fs-6" }, "Kebijakan Pembelian Kartu")
  ])
], -1)
const _hoisted_8 = { class: "mb-15" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mh-375px scroll-y me-n7 pe-7 mb-20 bg-light rounded" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "m-6" }, [
    /*#__PURE__*/_createElementVNode("text", null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui orci, fermentum nisl, ornare potenti vitae, gravida tincidunt. Malesuada commodo aliquam pulvinar arcu elit tellus. Sit aliquam feugiat ut eget venenatis adipiscing neque eget in. Pulvinar molestie porttitor iaculis sit. Pretium enim porttitor tincidunt porta donec auctor cras volutpat. Morbi quis id adipiscing tellus. Eu sed id orci mi, quam. Amet, nec imperdiet id molestie velit. Phasellus sollicitudin sit euismod ac in nisl pharetra. Blandit a aliquet tristique amet, quam diam malesuada. Nibh quis varius ultricies blandit integer nulla orci dui. Orci sit ac non massa risus donec. Elementum id duis orci, aliquet sit neque nisi. Pretium laoreet mauris, vel gravida quam morbi imperdiet et nibh. Massa aliquam sem feugiat faucibus cursus in volutpat. Velit maecenas ultricies sit pulvinar hac. Fermentum semper at morbi in. Magna cum id mauris sit sit curabitur nisl. Egestas facilisis adipiscing aliquam viverra ultricies condimentum. Et mi est tempor id arcu, adipiscing enim quam. Consectetur integer aliquet tincidunt adipiscing lorem fames commodo. Amet maecenas arcu suscipit eu blandit. Convallis non fringilla tempor eget orci urna et mi. Vel scelerisque commodo id dui interdum id semper non non. Massa sem facilisis id magna malesuada fermentum posuere. Eu dolor faucibus ut lectus. Quam justo, nisl sed mauris nulla id. Semper scelerisque at morbi risus integer consectetur urna. Tristique tempus, malesuada vitae justo. Habitant ullamcorper malesuada nisl mus ultrices. ")
  ])
], -1)
const _hoisted_10 = { class: "form-check mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nibh lacus orci tellus lacus. Sapien bibendum tellus in platea dui habitasse elementum molestie. Sed at ", -1)
const _hoisted_12 = {
  class: "modal-footer justify-content-center",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.isChecked]
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-success",
                disabled: !_ctx.isChecked,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (this.createCart()))
              }, " Simpan ", 8, _hoisted_14)
            ])
          ])
        ])
      ])
    ])
  ]))
}